import Swal from "sweetalert2";

const TRASH_DELETE_COMMENT_STYLE_ID = "swal-trash-delete-comment-styles";

function ensureTrashDeleteCommentStyles() {
  if (typeof document === "undefined") return;
  if (document.getElementById(TRASH_DELETE_COMMENT_STYLE_ID)) return;

  const style = document.createElement("style");
  style.id = TRASH_DELETE_COMMENT_STYLE_ID;
  style.textContent = `
    .swal-trash-comment-popup {
      width: min(560px, calc(100vw - 2rem)) !important;
      max-width: calc(100vw - 2rem) !important;
    }
    .swal-trash-comment-popup .swal2-html-container {
      overflow-x: hidden !important;
      max-width: 100%;
      margin: 0;
      padding: 0 1.25em;
    }
    .swal-trash-comment-content {
      width: 100%;
      max-width: 100%;
      overflow: hidden;
      text-align: left;
      box-sizing: border-box;
    }
    .swal-trash-comment-content p {
      margin-bottom: 0;
    }
    .swal-trash-comment-field-wrap {
      margin-top: 15px;
      width: 100%;
      max-width: 100%;
      box-sizing: border-box;
    }
    .swal-trash-comment-field-wrap label {
      display: block;
      margin-bottom: 6px;
      font-weight: 500;
    }
    #swal-delete-comment {
      display: block;
      width: 100% !important;
      max-width: 100% !important;
      min-width: 0 !important;
      box-sizing: border-box;
      margin: 0;
      padding: 0.5rem 0.75rem;
      resize: vertical;
      overflow-x: hidden;
      white-space: pre-wrap;
      word-break: break-word;
      border: 1px solid #d9d9d9;
      border-radius: 0.25rem;
      font: inherit;
      line-height: 1.4;
    }
  `;
  document.head.appendChild(style);
}

ensureTrashDeleteCommentStyles();

export function getTrashCommentField(fields) {
  if (!Array.isArray(fields)) return null;
  return fields.find((field) => field && field.key === "commentdelete") || null;
}

export function deleteCommentFieldHtml(t, field) {
  const label = field?.label ? t(field.label) : t("Comment");
  const placeholder = t("deleteCommentPlaceholder");
  return `
    <div id="swal-delete-comment-wrap" class="swal-trash-comment-field-wrap">
      <label for="swal-delete-comment">${label}</label>
      <textarea id="swal-delete-comment" rows="4" placeholder="${placeholder}"></textarea>
    </div>
  `;
}

export function buildTrashDeleteConfirmHtml({ messageHtml = "", commentHtml = "" } = {}) {
  return `<div class="swal-trash-comment-content">${messageHtml}${commentHtml}</div>`;
}

export function getTrashDeleteCommentSwalOptions(extra = {}) {
  ensureTrashDeleteCommentStyles();
  return {
    width: "auto",
    customClass: {
      popup: "swal-trash-comment-popup",
    },
    ...extra,
  };
}

export function readSwalDeleteComment() {
  const el = document.getElementById("swal-delete-comment");
  if (!el) return "";
  return String(el.value || "").trim();
}

export function trashDeleteCommentPreConfirm() {
  return readSwalDeleteComment();
}

/**
 * Soft delete: only when the model has commentdelete.
 * Permanent delete: always (also used by after_delete / email).
 */
export function shouldShowTrashDeleteComment(_modelName, trashCommentField, options = {}) {
  if (options && options.isPermanentDelete) return true;
  return !!trashCommentField;
}

export function buildTrashCommentFieldHtml(t, _modelName, field) {
  return deleteCommentFieldHtml(t, field || { key: "commentdelete" });
}

export function resolveTrashDeletePreConfirm(_modelName, _field) {
  return trashDeleteCommentPreConfirm;
}

export function trashDeleteCommentFromSwalResult(result) {
  if (!result || !result.isConfirmed) return "";
  return String(result.value || "").trim();
}

export function buildSoftDeleteRequestConfig(commentdelete) {
  if (!commentdelete) return {};
  return { data: { commentdelete } };
}

export function showTrashDeleteLoadingSwal() {
  Swal.fire({
    allowOutsideClick: false,
    allowEscapeKey: false,
    showConfirmButton: false,
    didOpen: () => {
      Swal.showLoading();
    },
  });
}

export function closeTrashDeleteLoadingSwal() {
  Swal.close();
}

/** Siempre visible: el comentario aplica también al borrado permanente (email after_delete). */
export function bindPermanentDeleteHidesDeleteComment(
  checkboxId = "swal-delete-permanently-detail"
) {
  const checkbox = document.getElementById(checkboxId);
  const commentWrap = document.getElementById("swal-delete-comment-wrap");
  if (!checkbox || !commentWrap) return;
  commentWrap.style.display = "block";
}

export const DELETE_PERMANENTLY_CHECKBOX_ID = "swal-delete-permanently";

export function deletePermanentlyCheckboxHtml(t, checkboxId = DELETE_PERMANENTLY_CHECKBOX_ID) {
  return `
    <div style="margin-top: 15px;">
      <label style="display: flex; align-items: center; cursor: pointer;">
        <input type="checkbox" id="${checkboxId}" style="margin-right: 8px; cursor: pointer;">
        <span>${t("Delete permanently")}</span>
      </label>
    </div>
  `;
}

/**
 * Engancha el checkbox "Delete permanently" al botón de confirmar (texto y color)
 * y avisa cada cambio con onChange(checked). Llamar desde didOpen.
 */
export function bindDeletePermanentlyCheckbox({
  trashText,
  permanentText,
  onChange,
  checkboxId = DELETE_PERMANENTLY_CHECKBOX_ID,
  trashColor = "#dc3545",
  permanentColor = "#8b0000",
} = {}) {
  const checkbox = document.getElementById(checkboxId);
  if (!checkbox) return;
  checkbox.addEventListener("change", (e) => {
    const checked = !!e.target.checked;
    const confirmButton = Swal.getConfirmButton();
    if (confirmButton) {
      confirmButton.textContent = checked ? permanentText : trashText;
      confirmButton.style.backgroundColor = checked ? permanentColor : trashColor;
    }
    if (typeof onChange === "function") onChange(checked);
  });
}

export { Swal };
